import { create } from 'zustand';

// ============================================================
// B4：渲染巡检 → AI 修复（报告一键转 AI 助手指令）
// - requestFix(prompt)：巡检弹窗写入修复指令并请求打开 AI 助手
// - autoRun：打开后自动生成计划（true=一键修复流程）
// ============================================================
interface InspectFixState {
  openRequest: number;
  prompt: string;
  autoRun: boolean;
  requestFix: (prompt: string) => void;
}

export const useInspectFixStore = create<InspectFixState>((set) => ({
  openRequest: 0,
  prompt: '',
  autoRun: false,
  requestFix: (prompt) => set((s) => ({ openRequest: s.openRequest + 1, prompt, autoRun: true })),
}));
